import clsx from "classnames";
import classes from "./styles.module.scss";
import Link from 'next/link';
import { useRouter } from 'next/router';
import SourceFlowApplicationForm from "@sourceflow-uk/sourceflowapplicationform";
import { formatDistanceToNow, fromUnixTime } from 'date-fns';
import { getContractType } from "@/functions/getContractType";
import Body from "@/ui/Body";
import { FormSection, TeamCard } from "..";
import BackButton from "../BackButton";
import Title from "@/ui/Title";
import Salary from "@/assets/Salary.svg";
import Location from "@/assets/Location.svg";
import TimeClock from "@/assets/TimeClock.svg";
import Phone from "@/assets/Phone.svg";
import Wallet from "@/assets/Wallet.svg";
import { formatAddress } from "@/functions/formatAddress";
import ArrowDown from "@/assets/ArrowDown.svg";
import Facebook from "@/assets/Facebook2.svg";
import LinkedIn from "@/assets/LinkedIn.svg";
import Email from "@/assets/Email.svg";
import Form from "@/ui/Form";
import { useEffect, useState } from "react";
import { getGlobal } from "@/functions/getGlobal";

export default function JobDetail({ className = "", job, consultant, color_variant }) {
  const global = getGlobal();
  const email = global["_theme.company.email"];

  const router = useRouter();
  const pathName = 'https://omegaresource.co.uk' + router.asPath;
  const location = job.categories.find((_item) => _item.name == "Location");
  const sector = job.categories.find((_item) => _item.name == "Sectors");
  const contractType = job.categories.find((_item) => _item.name == "Contract Type");

  var timeAgo = ''
  const createdAtDate = fromUnixTime(job.created_at);
  if (createdAtDate instanceof Date && !isNaN(createdAtDate)) {
    timeAgo = formatDistanceToNow(new Date(createdAtDate), { addSuffix: true });
  } else {
    timeAgo = formatDistanceToNow(new Date(job.created_at), { addSuffix: true });
  }

  return (
    <div className={clsx(className, classes.job)}>
      <div className={classes.hero}>
        <div className={classes.content}>
          <BackButton page="Jobs" link="/jobs" />
          <Title title={job.title} tag="h1" className={classes.title} />
          <div className={classes.highlights}>
            <div className={classes.highlight}>
              <Salary width={18} height={18} className={`fill secondary ${classes.icon}`} />
              <div className={classes.value}>{job.external_reference}</div>
            </div>
            <div className={classes.highlight}>
              <Location width={18} height={18} className={`fill secondary ${classes.icon}`} />
              <div className={classes.value}>{job.location}</div>
            </div>
            <div className={classes.highlight}>
              <TimeClock width={18} height={18} className={`fill secondary ${classes.icon}`} />
              <div className={classes.value}>{job.salary_package}</div>
            </div>
            <div className={classes.highlight}>
              <Wallet width={18} height={18} className={`fill secondary ${classes.icon}`} />
              <div className={classes.value}>{contractType?.values[0]?.name}</div>
            </div>
          </div>
        </div>
        <div className={classes.details}>
          <div className={classes.tags}>
            {sector.values.map((tag, index) => (
              <div key={index} className={clsx(classes.tag, 'bg', color_variant)}>
                {tag.name}
              </div>
            ))}
          </div>
          <Link href={"#job_application"} passHref className={classes.link}>
            <button className={classes.button}>
              Apply Now
              <ArrowDown width={18} height={18} className={classes.icon} />
            </button>
          </Link>
        </div>
      </div>
      <div className={classes.job_details}>
        <div className={classes.post_details}>
          <Body body={job.description} className={classes.body} />
          <div id="job_application" className={classes.job_application}>
            <Title title="Apply Now" tag="h4" className={classes.form_title} />
            <Form onSubmitDone={() => (window.location.href = "/thank-you-for-applying")} jobId={job.id} />
          </div>
        </div>
        <div className={classes.consultant_details}>
          {consultant.profile_image != undefined && <TeamCard item={consultant} color_variant={color_variant} />}
          <div className={classes.sharing}>
            <h5 className={classes.title}>Contact Me</h5>
            <div className={classes.socials}>
              <a
                className={classes.social_icon}
                href={consultant.linkedin}
                target="_blank"
                rel="nofollow"
              >
                <LinkedIn width={19} height={19} />
              </a>
              {consultant?.phone ? (
                <a className={classes.social_icon} href={"tel:" + consultant?.phone} target="_blank" rel="nofollow">
                  <Phone width={19} height={19} />
                </a>
              ) : (
                ""
              )}
              <a
                className={classes.social_icon}
                href={`mailto:${consultant.email}`}
                target="_blank"
                rel="nofollow"
              >
                <Email width={21} height={21} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}